const hi = {
  onboarding: {
    countryQuestion: "समझ गया! 🌍\n\nआप किस देश में हैं?",
    countryPlaceholder: "आप किस देश में हैं?",
    letsGo: "चलिए शुरू करें!",
    summaryIntro: "🎉 बहुत बढ़िया, {name}! सब तैयार है!",
    yourNameLabel: "आपका नाम",
    baseLanguageLabel: "आधार भाषा",
    goalsHint: "आप अपना शब्दावली लक्ष्य और कोर्स की अवधि कभी भी लक्ष्य पेज से बदल सकते हैं।",
    startLearning: "{destLang} सीखना शुरू करें!",
  },
  header: {
    learner: "शिक्षार्थी",
    home: "🏠 होम",
    allLessons: "📚 सभी पाठ",
    currentLesson: "📖 वर्तमान पाठ",
    flashcards: "🃏 फ्लैशकार्ड",
    progress: "📈 प्रगति",
    goals: "🎯 लक्ष्य",
    grammarLab: "📘 व्याकरण",
    more: "⋯ अधिक",
    myVocabulary: "📝 मेरी शब्दावली",
    listenSpeak: "🎧 सुनें और बोलें",
    signOut: "↩ साइन आउट",
  },
  lab: {
    title: "सुनें और बोलें प्रयोगशाला",
    back: "वापस",
    intro: "किसी ऐसे विषय पर Babi के साथ एक छोटी बातचीत करें जिसे आप पहले पढ़ चुके हैं।",
    pickTopic: "कोई ऐसा विषय चुनें जिसे आपने पूरा कर लिया है",
    noTopics: "पहले एक पाठ पूरा करें, फिर बोलने का अभ्यास करने के लिए यहाँ वापस आएं।",
    level: "स्तर {level}",
    talkAbout: "Babi से “{topic}” के बारे में बात करें",
    speedLabel: "Babi की गति",
    speedNormal: "सामान्य",
    speedSlow: "धीमी",
    speedNote: "धीमी गति एक ही जवाब के लिए आपके ज़्यादा वॉइस मिनट इस्तेमाल करती है।",
    startConversation: "बातचीत शुरू करें",
    tapToStart: "माइक पर टैप करें और Babi को तुर्की में जवाब दें।",
    continueConversation: "प्रश्न का उत्तर दें",
    finishSession: "समाप्त करें",
    voiceReviewHint: "आपने जो कहा उसे जांचें, फिर पुष्टि करें — या दोबारा करें।",
    voiceConfirm: "पुष्टि करें",
    voiceRedo: "दोबारा",
    voiceDenied: "माइक्रोफ़ोन एक्सेस के बिना आवाज़ उपलब्ध नहीं है। फिर से कोशिश करने के लिए कभी भी माइक आइकन पर टैप करें।",
    lowBalanceWarning: "इस मासिक चक्र के लिए आपके वॉइस मिनट खत्म होने वाले हैं।",
    thinking: "Babi सोच रहा है…",
    complete: "सत्र पूरा हुआ",
    completeSub: "अच्छा अभ्यास। किसी और विषय पर बात करने के लिए कभी भी वापस आएं।",
    another: "कोई और विषय अभ्यास करें",
    done: "हो गया",
    replyError: "Babi अभी जवाब नहीं दे सका। कृपया थोड़ी देर बाद फिर से कोशिश करें।",
    tryAgain: "फिर कोशिश करें",
    eliteUpsellTitle: "सुनें और बोलें एक Elite सुविधा है",
    eliteUpsellBody: "आप Pro प्लान पर हैं। Babi के साथ बोलने का अभ्यास करने के लिए सेटिंग्स में Elite में अपग्रेड करें।",
    listenAgainButton: "फिर से सुनें",
    listenAgainPlaying: "रोकें",
    translateButton: "अनुवाद करें",
    translating: "अनुवाद हो रहा है…",
    translateFailed: "अनुवाद नहीं हो सका — फिर से कोशिश करें।",
    starsAriaLabel: "3 में से {stars}",
    explainButton: "अधिक समझाएं",
    explaining: "समझाया जा रहा है…",
    explainFailed: "स्पष्टीकरण नहीं मिल सका — फिर से कोशिश करें।",
    recapHeading: "बातचीत रिपोर्ट",
    recapTitle: "आपका सारांश",
    recapAvgStars: "इस सत्र का औसत",
    recapTurnsCompleted: "{total} में से {completed} बारी पूरी हुईं",
    recapErrorFree: "{n} बारी बिना गलती के",
    recapMistakesByType: "प्रकार के अनुसार गलतियाँ",
    recapCorrections: "क्या सुधारा गया",
    voiceMinutesTitle: "वॉइस मिनट",
    voiceMinutesLeft: "इस चक्र में {total} में से {amount} शेष",
    voiceMinutesNone: "इस चक्र में कोई मासिक मिनट शेष नहीं",
  },
  dashboard: {
    greeting: "नमस्ते, {name}! 👋",
    streakMsg: "{streak} दिन की लकीर 🔥 — जारी रखो!",
    noStreak: "आज अपना पहला पाठ शुरू करें!",
    streakProtectionDays: "{n} स्ट्रीक सुरक्षा दिन अर्जित 🛡️",
    dayInfo: "आधार भाषा: {lang} · दिन {day} / {total}",
    dayStreak: "दिन लगातार",
    share: "साझा करें",
    wordsLearned: "सीखे गए शब्द",
    lessonsDone: "पूरे किए गए पाठ",
    goalComplete: "लक्ष्य पूर्ण",
    timeStudied: "अध्ययन समय",
    hoursUnit: "घंटे",
    paceTitle: "📊 दैनिक गति ट्रैकर",
    statusAhead: "🚀 {delta} शब्द आगे!",
    statusBehind: "⚡ {delta} शब्द पकड़ने हैं",
    statusOnTrack: "✅ बिल्कुल सही रास्ते पर!",
    paceTarget: "लक्ष्य: {wpd} शब्द/दिन · आज: {today} शब्द",
    paceExpected: "अपेक्षित: {n}",
    paceGoal: "लक्ष्य: {n}",
    actionCurrentLesson: "वर्तमान पाठ",
    actionAllLessons: "सभी पाठ",
    actionFlashcards: "फ्लैशकार्ड",
    actionProgress: "मेरी प्रगति",
    actionGoals: "मेरे लक्ष्य",
    actionMyVocabulary: "मेरी शब्दावली",
    actionGrammarLab: "व्याकरण प्रयोगशाला",
    actionListenSpeak: "सुनें और बोलें प्रयोगशाला",
    lessonsSub: "{count} विषय · {words} शब्द",
    cardsDue: "आज {n} कार्ड बकाया!",
    allCaughtUp: "सब पूरा! 🎉",
    progressSub: "चार्ट, सटीकता, शब्द भंडार वृद्धि",
    myVocabSub: "अब तक सीखे गए सभी शब्द देखें",
    listenSpeakSub: "Babi के साथ बोलने का अभ्यास करें",
    goalsSub: "{words} शब्द · {days} दिन",
    apiCost: "💰 API लागत ट्रैकर",
    since: "{date} से",
    resetBtn: "↺ रीसेट",
    totalTokens: "कुल टोकन",
    inputTokens: "इनपुट",
    outputTokens: "आउटपुट",
    estCost: "अनुमानित लागत",
    apiNote: "claude-sonnet-5 · $3/MTok in · $15/MTok out",
    tipLabel: "सुझाव:",
    tips: [
      "तुर्की में क्रिया हमेशा वाक्य के अंत में आती है — «Ben kahve içiyorum» का मतलब है «मैं कॉफी पी रहा हूँ।» बस पैटर्न को अपनाएं!",
      "तुर्की में स्वर सामंजस्य का उपयोग होता है — प्रत्यय अपने स्वर को मूल शब्द के अंतिम स्वर के अनुसार बदलते हैं (जैसे -lar/-ler, -da/-de)। एक बार समझ लें तो सब कुछ आसान हो जाता है!",
      "तुर्की में व्याकरणिक लिंग नहीं होता। पुल्लिंग या स्त्रीलिंग संज्ञाएं नहीं — फ्रेंच, स्पेनिश या जर्मन की तुलना में एक चीज कम याद करनी पड़ती है!",
      "व्यक्तिवाचक सर्वनाम (ben = मैं, sen = तुम) तुर्की में आमतौर पर छोड़ दिए जाते हैं क्योंकि क्रिया प्रत्यय पहले से कर्ता बताता है।",
      "तुर्की ध्वन्यात्मक रूप से नियमित है — हर अक्षर हमेशा एक ही तरह उच्चारित होता है। जो पढ़ते हैं वही बोलते हैं।",
      "नकारात्मकता क्रिया मूल के बाद सीधे -me/-ma जोड़कर बनती है: gel (आओ) → gelme (मत आओ), anla (समझो) → anlama।",
      "तुर्की में परसर्ग (postpositions) संज्ञा के बाद आते हैं: «İstanbul'da» = «इस्तांबुल में» (इस्तांबुल + स्थान प्रत्यय -da)।",
      "बहुवचन प्रत्यय स्वर सामंजस्य का पालन करता है: पश्च स्वरों (a, ı, o, u) के बाद -lar और अग्र स्वरों (e, i, ö, ü) के बाद -ler।",
      "प्रत्यय -ıyor/-iyor/-uyor/-üyor वर्तमान प्रगामी काल को दर्शाता है। Anlıyorum = मैं समझ रहा हूँ (anla + ıyor + um)।",
      "तुर्की संयुक्त क्रियाएं किसी संज्ञा को etmek (करना) या olmak (होना) के साथ जोड़ती हैं: teşekkür etmek (धन्यवाद करना), hazır olmak (तैयार होना)।",
    ],
  },
  lesson: {
    backBtn: "← वापस",
    topicOf: "विषय {order}/{total} · {words} शब्द",
    translating: "पाठ तैयार किया जा रहा है…",
    newWords: "✨ नए शब्द ({n})",
    alreadyLearned: "🔄 पहले से सीखे ({n})",
    practiceDialogue: "🎭 अभ्यास",
    generateDialogue: "🎭 मुझे एक अभ्यास संवाद दें",
    listenSpeakPractice: "🎧 सुनें और बोलें प्रयोगशाला में अभ्यास करें",
    generatingDialogue: "Babi आपका संवाद तैयार कर रहा है…",
    newDialogue: "↺ नया संवाद",
    lessonSaved: "🎉 पाठ सहेजा गया! {n} नए फ्लैशकार्ड जोड़े जा रहे हैं…",
    alreadyTaken: "✅ पाठ पहले ही पूरा किया",
    markComplete: "✅ पाठ पूरा करें और फ्लैशकार्ड सहेजें",
  },
  vocab: {
    structure: "संरचना",
    loadingExample: "लोड हो रहा है…",
    limitReached: "↺ सीमा पहुंच गई",
    anotherLeft: "↺ एक और ({n} बचे)",
    anotherExample: "↺ एक और उदाहरण",
    analyzing: "विश्लेषण हो रहा है…",
    analyzed: "✓ विश्लेषण हुआ",
    analyzeWord: "🔍 शब्द का विश्लेषण",
    analysisIntro: "यहाँ चरण-दर-चरण व्याकरणिक विश्लेषण है:",
    analysisError: "विश्लेषण लोड नहीं हो सका। कृपया पुनः प्रयास करें।",
    reportMistake: "🚩 गलती की रिपोर्ट करें",
    reportWrongMeaning: "शब्द का अर्थ गलत है",
    reportWrongSentence: "वाक्य का अर्थ गलत है",
    reportOther: "अन्य",
    reportChecking: "जाँच हो रही है…",
    reportThanks: "✓ सुधार में मदद करने के लिए धन्यवाद!",
    reportNoIssue: [
      "मुझे यहाँ कोई समस्या नहीं मिली — यह मुझे सही लगता है!",
      "मुझे यहाँ कोई समस्या नज़र नहीं आ रही — यह सही लगता है।",
      "मेरी नज़र में सब कुछ ठीक लग रहा है।",
      "मुझे कोई समस्या नहीं मिली; जैसा लिखा गया है वह सही लगता है।",
      "यह मुझे अच्छा लगता है — मुझे कोई चिंता नहीं है।",
      "मैंने इसकी समीक्षा की और बदलने लायक कुछ नहीं मिला।",
      "मुझे कोई समस्या नज़र नहीं आई; अनुवाद सही लगता है।",
      "जहाँ तक मैं देख पा रहा हूँ, सब कुछ सही है।",
      "मुझे कोई समस्या नहीं मिल पाई; यह मुझे ठीक लगता है।",
    ],
    reportCheckError: "जाँच पूरी करने में समस्या हुई। कृपया बाद में फिर से प्रयास करें।",
    reportOkBtn: "ठीक है, समझ गया",
    reportEscalateBtn: "किसी मानव समीक्षक को भेजें",
    reportEscalatedMsg: "✓ हमारी समीक्षा टीम को भेज दिया गया। धन्यवाद!",
    reportAlreadyFlaggedMsg: "✓ इसे पहले ही हमारी समीक्षा टीम को फ़्लैग किया जा चुका है। धन्यवाद!",
  },
  allLessons: {
    title: "📚 सभी पाठ",
    subtitle: "{count} विषय · {words} शब्द",
    searchPlaceholder: "🔍 विषय या शब्द खोजें…",
    noResults: "\"{search}\" से मेल खाने वाला कोई विषय नहीं",
    overwhelmedBanner: "आपके पास {n} कार्ड समीक्षा के लिए हैं। कृपया नए पाठ शुरू करने से पहले फ्लैशकार्ड की समीक्षा करें।",
    overwhelmedLock: "पहले फ्लैशकार्ड की समीक्षा करें",
    overwhelmedBtn: "फ्लैशकार्ड पर जाएं →",
  },
  flashcards: {
    title: "फ्लैशकार्ड",
    cardOf: "कार्ड {current} / {total}",
    tapToReveal: "दिखाने के लिए टैप करें",
    hearIt: "🔊 सुनें",
    hearSentence: "🔊 वाक्य सुनें।",
    allConsolidated: "सब स्थापित",
    noDue: "अभी कोई कार्ड बकाया नहीं।\nआपकी याददाश्त अच्छी तरह आराम कर चुकी है।",
    backToDashboard: "डैशबोर्ड पर वापस",
    sessionComplete: "सत्र पूर्ण",
    memoryRetention: "स्मृति दक्षता",
    forgotten: "भूल गया",
    struggled: "कठिन था",
    recalled: "याद आया",
    effortless: "आसान था",
    wordsConsolidated: "{total} में से {retained} शब्द स्थापित",
    wordsInProgress: "{total} में से {retained} शब्द प्रगति में",
    saveContinue: "सहेजें और जारी रखें",
    tomorrow: "कल",
    nDays: "{n} दिन",
    d1Title: "समझ",
    d1SubSkill: "पढ़ने और सुनने की कौशल में सुधार के लिए",
    d1Journey: "नए शब्द यहाँ से अपनी यात्रा शुरू करते हैं।",
    d1Due: "{n} बाकी",
    d1Listen: "सुनें",
    d1ShowWord: "शब्द दिखाएं",
    d2Title: "उत्पादन",
    d2SubSkill: "बोलने और लिखने की कौशल में सुधार के लिए",
    d2WillStart: "बाद में शुरू होगा",
    d2Empty: "बोध फ्लैशकार्ड सेट में अच्छी तरह सीखने के बाद शब्द यहाँ आते हैं।",
    d2ModalTitle: "उत्पादन अभ्यास अनलॉक हो गया!",
    d2ModalBody: "ये वे शब्द हैं जिन्हें आप पहले से अच्छी तरह पहचानते हैं। अब हम आपको इन्हें उत्पादित करना सिखाते हैं — इस तरह आप {targetLang} को समझने से बोलने तक पहुँचते हैं।",
    d2ModalBtn: "समझ गया",
    leaveConfirmTitle: "बिना सहेजी गई समीक्षा प्रगति",
    leaveConfirmBody: "आपने इस सत्र में जिन कार्ड्स की समीक्षा की है, वे अभी तक सहेजे नहीं गए हैं। यदि आप अभी बिना सहेजे बाहर जाते हैं, तो यह प्रगति खो जाएगी।",
    leaveConfirmSave: "सहेजें और बाहर जाएं",
    leaveConfirmDiscard: "छोड़ें और बाहर जाएं",
    leaveConfirmCancel: "रद्द करें",
    faq: {
      whyTwoQ: "दो डेक क्यों?",
      whyLaterQ: "उत्पादन फ्लैशकार्ड सेट बाद में क्यों शुरू होता है?",
      whyReturnQ: "कार्ड वापस क्यों आते हैं?",
    },
  },
  grammarLab: {
    title: "📘 व्याकरण प्रयोगशाला",
    subtitle: "खोजने के लिए {count} व्याकरण बिंदु",
    backBtn: "← वापस",
    searchPlaceholder: "🔍 व्याकरण बिंदु खोजें…",
    noResults: "\"{search}\" से मेल खाने वाला कोई व्याकरण बिंदु नहीं मिला",
    allCategories: "सभी श्रेणियाँ",
    allLevels: "सभी स्तर",
    notReviewedLabel: "समीक्षा नहीं हुई",
    reviewedLabel: "समीक्षा हो गई",
    dueBadge: "{n} दोहराने बाकी",
    explanationLabel: "व्याख्या",
    seeReference: "({term} देखें)",
    ruleLabel: "नियम",
    formsLabel: "रूप",
    translatingNote: "हिंदी में अनुवाद हो रहा है...",
    practiceBtn: "▶ इस बिंदु का अभ्यास करें",
    detailedExplanationBtn: "📖 विस्तृत व्याख्या",
    practiceTitle: "अभ्यास",
    practiceQuestion: "इसे तुर्की में कैसे कहेंगे?",
    practiceOf: "{total} में से {current}",
    practiceCorrectFeedback: "सही!",
    practiceIncorrectFeedback: "बिल्कुल नहीं — सही उत्तर था {answer}।",
    practiceNext: "अगला →",
    practiceDone: "अभ्यास पूरा हुआ",
    practiceScore: "{total} में से {correct} सही",
    practiceNextReview: "अगली समीक्षा {days} दिन में",
    practiceReset: "इस बार नहीं — आप कल फिर इस बिंदु को देखेंगे।",
    practiceAgainBtn: "फिर से अभ्यास करें",
    practiceCloseBtn: "हो गया",
    categories: {
      existential: "अस्तित्वबोधक",
      noun_suffix: "संज्ञा प्रत्यय",
      case_suffix: "कारक प्रत्यय",
      verb_conjugation: "क्रिया रूपांतरण",
      question_particle: "प्रश्नवाचक अव्यय",
      copula: "सहायक क्रिया",
      modal_construction: "वृत्यात्मक संरचना",
    },
    points: {
      GP0001: { title: "अस्तित्व और उपलब्धता: var / yok", ruleSummary: "[स्थान/स्वामी] + [वस्तु] + var / yok" },
      GP0002: { title: "बहुवचन प्रत्यय: -ler / -lar", ruleSummary: "संज्ञा + -ler (अग्र स्वर) / -lar (पश्च स्वर)" },
      GP0003: { title: "अधिकरण कारक: -de / -da / -te / -ta", ruleSummary: "संज्ञा + -de/-da; अघोष व्यंजन के बाद -te/-ta" },
      GP0004: { title: "संप्रदान कारक: -e / -a", ruleSummary: "संज्ञा + -e/-a; स्वर के बाद संयोजक -y- जोड़ा जाता है" },
      GP0005: { title: "अपादान कारक: -den / -dan / -ten / -tan", ruleSummary: "संज्ञा + -den/-dan; अघोष व्यंजन के बाद -ten/-tan" },
      GP0006: { title: "कर्म कारक (निश्चित प्रत्यक्ष कर्म): -i / -ı / -u / -ü", ruleSummary: "संज्ञा + -i/-ı/-u/-ü; स्वर के बाद संयोजक -y-" },
      GP0007: { title: "वर्तमान अपूर्ण काल — सकारात्मक: -iyor", ruleSummary: "क्रिया मूल + -iyor + पुरुषवाचक प्रत्यय" },
      GP0008: { title: "वर्तमान अपूर्ण काल — नकारात्मक: -mıyor / -miyor / -muyor / -müyor", ruleSummary: "क्रिया मूल + -mıyor/-miyor/-muyor/-müyor + पुरुषवाचक प्रत्यय" },
      GP0009: { title: "वर्तमान अपूर्ण काल — प्रश्नवाचक: -iyor mu", ruleSummary: "मूल + -iyor + mu(+पुरुषवाचक); onlar: मूल + -iyorlar + mı" },
      GP0010: { title: "हाँ/नहीं प्रश्नवाचक अव्यय: mı / mi / mu / mü", ruleSummary: "[शब्द] + अलग लिखा गया अव्यय mı/mi/mu/mü ?" },
      GP0011: { title: "सामान्य भूतकाल: -di / -dı / -du / -dü / -ti / -tı / -tu / -tü", ruleSummary: "क्रिया मूल + -di/-dı/-du/-dü (या अघोष के बाद -ti/...) + पुरुषवाचक प्रत्यय" },
      GP0012: { title: "'होना' क्रिया के विधेय प्रत्यय (वर्तमान): -(y)ım, -sin, -ø, -(y)ız, -siniz", ruleSummary: "विधेय + -(y)ım / -sin / -ø / -(y)ız / -siniz / (-lar)" },
      GP0013: { title: "संबंधवाचक प्रत्यय: मेरा / तुम्हारा / उसका / हमारा / तुम्हारा / उनका", ruleSummary: "(benim/senin/...) संज्ञा + -im/-in/-i/-imiz/-iniz/-leri" },
      GP0014: { title: "इच्छा व्यक्त करना: -mek / -mak istemek", ruleSummary: "[अनन्त रूप -mek/-mak] + istemek (रूपांतरित)" },
      GP0015: { title: "विनम्र अनुरोध / द्वितीय पुरुष बहुवचन आज्ञार्थक: -in / -iniz", ruleSummary: "क्रिया मूल + -in/-ın/-un/-ün (विनम्र) या -iniz (अधिक औपचारिक); स्वर के बाद संयोजक -y-" },
    },
  },
  placementTest: {
    title: "🎯 प्लेसमेंट टेस्ट",
    offerTitle: "क्या आपको पहले से थोड़ी तुर्की आती है?",
    offerBody: "अपना शुरुआती स्तर जानने के लिए एक छोटा प्लेसमेंट टेस्ट दें — लगभग 20 सवाल। हम उसी के अनुसार आपका मौजूदा पाठ सेट करेंगे, लेकिन सभी विषय ब्राउज़ करने के लिए खुले रहेंगे।",
    startBtn: "टेस्ट शुरू करें",
    notNowBtn: "अभी नहीं",
    roundLabel: "राउंड {round} / {totalRounds}",
    questionLabel: "सवाल {n} / {total}",
    wordPrompt: "इस शब्द का क्या मतलब है?",
    listeningPrompt: "सुनें और वह शब्द चुनें जो आपने सुना",
    listeningReplay: "फिर से सुनें",
    preparingRound: "आपके प्रश्न तैयार किए जा रहे हैं…",
    finishBtn: "मेरा परिणाम देखें",
    resultsTitle: "आपका प्लेसमेंट परिणाम",
    resultsLevel: "आपको {level} स्तर पर रखा गया है",
    resultsBody: "आपका मौजूदा पाठ अब इसी स्तर से शुरू होता है। आप कभी भी सभी पाठ में पहले या बाद के किसी भी विषय को ब्राउज़ कर सकते हैं।",
    continueBtn: "जारी रखें",
  },
  goals: {
    title: "🎯 मेरे लक्ष्य",
    displayName: "प्रदर्शन नाम",
    namePlaceholder: "आपका नाम…",
    vocabTarget: "शब्द भंडार लक्ष्य",
    words: "शब्द",
    minWords: "न्यूनतम 1,500",
    midWords: "2,000",
    maxWords: "अधिकतम 3,500",
    courseDuration: "लक्ष्य पाठ्यक्रम अवधि",
    months: "महीने",
    month: "महीना",
    monthsPlural: "महीने",
    daysSummary: "= {days} दिन",
    baseLanguage: "आधार भाषा",
    otherLanguage: "अन्य भाषाएँ (जल्द आ रही हैं)",
    selectLanguage: "भाषा चुनें…",
    ok: "ठीक है",
    langNames: {
      English: "अंग्रेज़ी", Farsi: "फ़ारसी", Arabic: "अरबी",
      French: "फ्रेंच", German: "जर्मन", Spanish: "स्पेनिश",
      Russian: "रूसी", Portuguese: "पुर्तगाली", Chinese: "चीनी",
      Turkish: "तुर्की", Hindi: "हिन्दी", Italian: "इतालवी",
    },
    targetLanguage: "लक्ष्य भाषा",
    targetLangNames: {
      Turkish: "तुर्की",
    },
    wordsLbl: "शब्द",
    wordsPerDay: "शब्द/दिन",
    daysLbl: "दिन",
    saved: "✅ लक्ष्य सहेजे गए!",
  },
  progress: {
    title: "📈 मेरी प्रगति",
    memDistTitle: "स्मृति स्थिति वितरण · {n} कार्ड",
    inAcquisition: "अर्जन में",
    rooted: "स्थापित",
    fluent: "प्रवाही",
    deeplyRetained: "गहराई से याद",
    acqDesc: "स्थिरता < 3 दिन",
    rootedDesc: "स्थिरता 3–21 दिन",
    fluentDesc: "स्थिरता 21–90 दिन",
    retainedDesc: "स्थिरता 90+ दिन",
    forecastTitle: "पुनरावलोकन पूर्वानुमान — अगले 15 दिन",
    cardsDue: "बकाया कार्ड",
    today: "आज",
    tmrw: "कल",
    plusDays: "+{n}दि",
    todayFull: "आज",
    tmrwFull: "कल",
    plusDaysFull: "+{n} दिन",
    goalProgress: "समग्र लक्ष्य प्रगति",
    wordsLearned: "{learned} / {target} शब्द सीखे",
    vocabGrowth: "शब्द भंडार वृद्धि",
    noChart: "चार्ट देखने के लिए पहला पाठ पूरा करें! 📚",
    wordsLearnedSeries: "सीखे गए शब्द",
    topicRings: "विषय स्मृति छल्ले",
    quickStats: "त्वरित आँकड़े",
    dayStreak: "दिन लगातार 🔥",
    lessonsDone: "पाठ पूरे",
    totalStudy: "कुल अध्ययन",
    avg14Day: "14-दिन औसत",
    minUnit: "मिनट",
    dayLabel: "दिन {n}",
    cards: "कार्ड",
  },
  myVocab: {
    title: "📝 मेरी शब्दावली",
    summaryTitle: "{n} शब्द सीखे गए",
    searchPlaceholder: "🔍 अपने शब्द खोजें…",
    allStatuses: "सभी स्थितियाँ",
    noResults: "\"{search}\" से कोई शब्द मेल नहीं खाता",
    noWords: "अपनी शब्दावली बनाना शुरू करने के लिए एक पाठ पूरा करें! 📚",
    completedTopicsTitle: "पूर्ण किए गए विषय ({n} में से {total})",
    noDate: "—",
  },
  badges: {
    newbie: "नौसिखिया",
    wordExplorer: "शब्द खोजी",
    wordNerd: "शब्दों का दीवाना",
    wordWizard: "शब्दों का जादूगर",
    rockstar: "रॉकस्टार",
    expert: "विशेषज्ञ",
    champion: "चैंपियन",
  },
  memStates: {
    inAcquisition: "अर्जन में",
    rooted: "स्थापित",
    fluent: "प्रवाही",
    deeplyRetained: "गहराई से याद",
  },
  chat: {
    subtitle: "आपका तुर्की शिक्षक",
    greetWords: ["नमस्ते", "हैलो", "प्रिय"],
    greeting: "{greet} {name},\n\nतुर्की भाषा — व्याकरण, शब्द भंडार, संस्कृति — या इस ऐप के उपयोग के बारे में कुछ भी पूछें।",
    placeholder: "तुर्की या ऐप के बारे में पूछें…",
    error: "क्षमा करें, अभी कनेक्ट नहीं हो सका। कृपया पुनः प्रयास करें।",
    escalationFallback: "क्षमा करें, मैं इसमें पूरी तरह से मदद नहीं कर सका। मैंने इसे हमारी टीम को भेज दिया है, और आपको ईमेल द्वारा जवाब मिलेगा — आमतौर पर 2 कार्य दिवसों के भीतर। आप हमसे सीधे support@speafy.com पर भी संपर्क कर सकते हैं।",
    welcome: "नमस्ते, {name}! 👋 Speafy में आपका स्वागत है! मैं बाबी हूं, और मैं दो चीज़ों के लिए यहां हूं: ऐप में आपकी मदद करना, और {targetLanguage} से जुड़े आपके किसी भी सवाल का जवाब देना।\n\nवर्तमान पाठ से शुरू करें, या सभी पाठ से कोई विषय चुनें। जब भी पाठ पूरा करें तो उसे पूर्ण के रूप में चिह्नित करना न भूलें, फिर फ्लैशकार्ड की समीक्षा करें।\n\nकभी भी मुझसे पूछें — ऐप के बारे में या {targetLanguage} के बारे में।\n\nआपकी सीखने की यात्रा में शुभकामनाएं! 😊",
    lessonLimit: "आपने आज {limit} पाठ पूरे किए — शानदार प्रयास! 🌟\n\nआपकी सीखने को टिकाऊ रखने और फ्लैशकार्ड की कतार अधिक न होने के लिए प्रतिदिन {limit} पाठों की सीमा है।\n\nअपने मस्तिष्क को आज सीखे हुए को समेकित करने का समय दें। बजाय इसके फ्लैशकार्ड समीक्षा सत्र क्यों न करें?\n\nकल और अधिक के लिए यहाँ रहूँगा! 😊",
    streakDecayed: "वापसी पर स्वागत है! 👋 आप {days} दिन दूर रहे। आपके द्वारा अर्जित {protection} स्ट्रीक सुरक्षा दिनों 🛡️ की बदौलत, आपकी स्ट्रीक पूरी तरह खत्म होने के बजाय सिर्फ {oldStreak} से {newStreak} पर आई। चलिए इसे फिर से बनाते हैं!",
    streakWiped: "वापसी पर स्वागत है! 👋 आप {days} दिन दूर रहे — यह आपके जमा किए {protection} स्ट्रीक सुरक्षा दिनों 🛡️ से ज़्यादा था, इसलिए आपकी स्ट्रीक 1 से फिर शुरू हुई। हर स्ट्रीक कहीं न कहीं से शुरू होती है — चलिए इसे फिर से बनाते हैं!",
    weeklyRecapFallback: "नमस्ते! 👋 मैं आपको आपका साप्ताहिक सारांश देना चाहता था, लेकिन अभी इसे तैयार करने में समस्या हो रही है। बस एक जल्दी बात — आपकी {streak}-दिन की स्ट्रीक चल रही है, इसे जारी रखें! 🔥",
    dailyPlanQuestion1: "नमस्ते! 👋 आज आपके पास पढ़ाई के लिए कितना समय है?",
    dailyPlanQuestion2: "नमस्ते! 😊 आपके लिए एक स्टडी प्लान तैयार है — आज आप कितने मिनट दे सकते हैं?",
    dailyPlanQuestion3: "आज की योजना के लिए तैयार हैं? 🎯 बस मुझे बताएं कि आपके पास लगभग कितना समय है।",
    dailyPlanClarify: "माफ़ कीजिए, मैं समझ नहीं पाया! क्या आप मुझे एक अनुमानित संख्या दे सकते हैं, जैसे '20' या '30 मिनट'?",
    dailyPlanUnreasonable: "यह एक सामान्य अध्ययन सत्र जैसा नहीं लगता! क्या आप मुझे 5 मिनट से लेकर लगभग 5 घंटे के बीच कुछ बता सकते हैं?",
    dailyPlanGiveUp: "कोई बात नहीं — जब भी आप तैयार हों, बस फ्लैशकार्ड या अपने वर्तमान पाठ पर जाएं और शुरू करें! 😊",
    dailyPlanFallback: "मैंने आपका उपलब्ध समय नोट कर लिया है, लेकिन अभी आज की योजना बनाने में समस्या हो रही है। इस बीच, अगर आपके पास ड्यू कार्ड्स हैं तो फ्लैशकार्ड हमेशा एक अच्छा विकल्प है! 😊",
    sendBtn: "भेजें",
    askBabi: "Babi से पूछें",
    voiceConsentTitle: "Babi के साथ वॉइस चैट चालू करें?",
    voiceConsentBody: "Babi आपकी बात सुनने के लिए आपके माइक्रोफ़ोन का और जवाब देने के लिए आपके स्पीकर का उपयोग करेगी। आपकी आवाज़ को टेक्स्ट में बदला जाता है — ऑडियो रिकॉर्डिंग कभी सुरक्षित नहीं रखी जाती। टेक्स्ट को 30 दिनों तक रखा जा सकता है। विवरण के लिए हमारी गोपनीयता नीति देखें।",
    voiceConsentPrivacyLink: "गोपनीयता नीति",
    voiceConsentAllow: "माइक्रोफ़ोन की अनुमति दें",
    voiceConsentDecline: "अभी नहीं",
    voiceDenied: "माइक्रोफ़ोन एक्सेस के बिना वॉइस चैट उपलब्ध नहीं है। आप टाइप करके चैट जारी रख सकते हैं — फिर से कोशिश करने के लिए कभी भी माइक आइकन पर टैप करें।",
    voiceDeviceInUse: "लगता है आपका माइक्रोफ़ोन कहीं और उपयोग हो रहा है — उसे उपयोग करने वाले अन्य ऐप बंद करें और फिर से कोशिश करें।",
    voiceError: "वॉइस चैट में कुछ गड़बड़ हो गई। कृपया फिर से कोशिश करें।",
    voiceStarting: "शुरू हो रहा है… कृपया प्रतीक्षा करें",
    voiceListening: "सुन रही हूं…",
    voiceProcessing: "समझ रही हूं…",
    voiceReviewHint: "संपादित करने के लिए टैप करें, या यह कुछ सेकंड में अपने आप भेज दिया जाएगा।",
    voiceSendNow: "अभी भेजें",
    voiceDiscard: "हटाएं",
    voiceEditTranscript: "Babi ने जो सुना उसे संपादित करें",
    voiceBadgeLabel: "आवाज़ से भेजा गया",
    voiceDidntCatch: "वह समझ नहीं आया — फिर से कोशिश करने के लिए माइक पर टैप करें।",
    voiceSpeaking: "Babi बोल रही है…",
    voiceTtsUnavailable: "उस जवाब के लिए ऑडियो उपलब्ध नहीं था — इसके बजाय टेक्स्ट दिखाया जा रहा है।",
    voiceTtsUnavailableLanguage: "Babi का बोला हुआ जवाब अभी {language} में उपलब्ध नहीं है।",
    voiceTapToHear: "Babi का जवाब सुनने के लिए टैप करें",
    voiceNotEntitled: "Babi के साथ वॉइस चैट एक प्रीमियम सुविधा है — इसका उपयोग करने के लिए अपग्रेड करें।",
    voiceNoBalance: "आपने इस चक्र के लिए अपने सभी वॉइस मिनट उपयोग कर लिए हैं। वे अगले चक्र में फिर से मिलेंगे।",
    voiceOtherTabActive: "वॉइस चैट पहले से ही किसी अन्य टैब में सक्रिय है।",
    voiceLowBalanceNudge: "इस चक्र के लिए वॉइस मिनट कम होते जा रहे हैं।",
    voiceLowMinutesHeadsUp: "इस चक्र के लिए वॉइस मिनट कम होते जा रहे हैं।",
    voiceGetMoreMinutes: "अधिक मिनट प्राप्त करें",
    voiceStopBtn: "रोकें",
    voiceMicButtonLabel: "वॉइस चैट",
    voiceBannerDismiss: "खारिज करें",
  },
  settings: {
    title: "सेटिंग्स",
    accountSection: "खाता",
    linkedGoogle: "Google से जुड़ा हुआ",
    emailAccountBadge: "ईमेल खाता",
    changeNameBtn: "उपयोगकर्ता नाम बदलें",
    nameSaveBtn: "सहेजें",
    nameCancelBtn: "रद्द करें",
    nameSaving: "सहेजा जा रहा है…",
    passwordLabel: "पासवर्ड",
    passwordSub: "अपने ईमेल पर रीसेट लिंक भेजें",
    passwordSent: "भेजा गया ✓",
    passwordResetBtn: "रीसेट करें",
    subscriptionSection: "सदस्यता",
    subscriptionAdminLabel: "एडमिन खाता",
    subscriptionAdminSub: "आपके पास सभी सुविधाओं तक पूर्ण, स्थायी पहुंच है।",
    subscriptionReviewerLabel: "समीक्षक पहुंच",
    subscriptionReviewerSub: "आपके पास ऐप समीक्षक के रूप में सभी सुविधाओं तक निःशुल्क पहुंच है।",
    subscriptionProPlan: "Speafy Pro — {plan}",
    subscriptionElitePlan: "Speafy Elite — {plan}",
    subscriptionPlanAnnual: "वार्षिक",
    subscriptionPlanMonthly: "मासिक",
    subscriptionRenews: "{date} को नवीनीकृत होगी",
    subscriptionActive: "सक्रिय",
    subscriptionManageLink: "बिलिंग और इनवॉइस",
    subscriptionCancelLink: "सदस्यता रद्द करें या रोकें",
    subscriptionPaymentFailedLabel: "आपका पिछला भुगतान विफल रहा",
    subscriptionPaymentFailedSub: "{date} को भुगतान विफल रहा",
    subscriptionPaymentFailedSubNoDate: "अपनी Pro पहुंच बनाए रखने के लिए कृपया अपना भुगतान तरीका अपडेट करें",
    subscriptionUpdatePaymentLink: "भुगतान तरीका अपडेट करें ↗",
    subscriptionCancelledPending: "आपकी योजना {date} को समाप्त होती है — तब तक आपकी Pro पहुंच बनी रहेगी",
    subscriptionPausedLabel: "सदस्यता रोकी गई",
    subscriptionPausedSub: "{date} को स्वतः फिर से शुरू हो जाएगी — जब तक आप पहले फिर से शुरू न करें, तब तक एक नए अवधि के लिए पूरा शुल्क लिया जाएगा",
    subscriptionPausedSubNoDate: "3 महीने बाद स्वतः फिर से शुरू हो जाएगी, जब तक आप पहले फिर से शुरू न करें",
    subscriptionResumeBtn: "अभी फिर से शुरू करें",
    subscriptionResuming: "फिर से शुरू हो रहा है…",
    pausePendingLabel: "रोक निर्धारित है",
    pausePendingSub: "आपकी मौजूदा बिलिंग अवधि के अंत में, {date} को लागू होगी",
    manageOfferTitle: "क्या आप रद्द करने के बारे में सोच रहे हैं?",
    manageOfferSub: "इसके बजाय रोकें — आप {date} तक अपनी प्रगति बनाए रखेंगे, फिर 3 महीने बाद सदस्यता स्वतः फिर से शुरू हो जाएगी और एक नई अवधि के लिए पूरा शुल्क लिया जाएगा, जब तक आप पहले फिर से शुरू न करें।",
    manageOfferPauseBtn: "इसके बजाय रोकें",
    manageOfferContinueLink: "फिर भी रद्द करें",
    manageOfferDismiss: "रहने दें",
    pauseOfferLabel: "थोड़ा ब्रेक चाहिए?",
    pauseOfferSub: "रद्द करने के बजाय अपनी सदस्यता को 3 महीने के लिए रोकें — अपनी प्रगति बनाए रखें, कभी भी फिर से शुरू करें।",
    pauseOfferBtn: "सदस्यता रोकें",
    pauseConfirmP1: "अपनी Speafy Pro सदस्यता रोकें?",
    pauseConfirmC1: "आपकी मौजूदा बिलिंग अवधि {date} तक जारी रहेगी — आपने जो भी पहले ही भुगतान किया है, वह आपके पास रहेगा।",
    pauseConfirmC2: "रुकने के दौरान, नए पाठ लॉक रहेंगे (समाप्त हो चुकी मुफ्त योजना की तरह), लेकिन आप अपने मौजूदा फ्लैशकार्ड सामान्य रूप से दोहरा सकते हैं।",
    pauseConfirmC3: "यह रोक निश्चित रूप से 3 महीने तक चलती है। यदि आप उससे पहले मैन्युअल रूप से फिर से शुरू नहीं करते हैं, तो आपकी सदस्यता स्वतः फिर से शुरू हो जाएगी और एक नई अवधि के लिए पूरा शुल्क लिया जाएगा।",
    pauseConfirmBtn: "रोक की पुष्टि करें",
    pausing: "रोका जा रहा है…",
    pauseFailedGeneric: "आपकी सदस्यता रोकने में कुछ गड़बड़ हो गई। कृपया फिर से प्रयास करें या सहायता से संपर्क करें।",
    manageLinkLoading: "लोड हो रहा है…",
    manageLinkFailedGeneric: "अभी प्रबंधन लिंक लोड नहीं हो सका। कृपया फिर से प्रयास करें।",
    resumeConfirmP1: "क्या अभी अपनी Speafy Pro सदस्यता फिर से शुरू करें?",
    resumeConfirmC1: "आपसे तुरंत एक नई बिलिंग अवधि के लिए पूरा शुल्क लिया जाएगा।",
    resumeConfirmBtn: "हां, अभी फिर से शुरू करें",
    resumeFailedGeneric: "आपकी सदस्यता फिर से शुरू करने में कुछ गड़बड़ हो गई। कृपया फिर से प्रयास करें या सहायता से संपर्क करें।",
    subscriptionLastCharge: "अंतिम शुल्क: {date} को {amount} — {status}",
    subscriptionLastChargePaid: "भुगतान किया गया",
    subscriptionLastChargeFailed: "विफल",
    tierChangePendingLabel: "प्लान परिवर्तन निर्धारित",
    tierChangePendingToElite: "{date} को Elite में बदला जाएगा",
    tierChangePendingToBasic: "{date} को, आपके मौजूदा बिलिंग अवधि के अंत में Pro में बदला जाएगा",
    tierUpgradeToEliteLink: "Elite में अपग्रेड करें",
    tierDowngradeToBasicLink: "Pro पर वापस जाएं",
    tierUpgradeConfirmTitle: "Elite में अपग्रेड करें?",
    tierUpgradeConfirmSub: "आज से आपसे आनुपातिक अंतर लिया जाएगा, और आपको तुरंत Babi के साथ Elite के 3 घंटे की वॉइस बातचीत मिल जाएगी — इसके बाद {price}/{interval}।",
    tierDowngradeConfirmTitle: "Pro पर वापस जाएं?",
    tierDowngradeConfirmSub: "आप {date} तक Elite बनाए रखेंगे, फिर अपनी अगली बिलिंग तारीख पर Pro में बदल जाएंगे — आज कोई शुल्क नहीं।",
    tierUpgradeConfirmBtn: "हां, अभी अपग्रेड करें",
    tierDowngradeConfirmBtn: "हां, Pro पर वापस जाएं",
    tierChangeBusy: "अपडेट हो रहा है…",
    tierChangeFailedGeneric: "आपका प्लान बदलने में कुछ गड़बड़ हुई। कृपया फिर से प्रयास करें या सहायता से संपर्क करें।",
    voiceMinutesLabel: "वॉइस मिनट ({tier})",
    voiceTierElite: "Elite",
    voiceTierBasic: "Pro",
    voiceTierTrial: "ट्रायल",
    voiceTierAdmin: "एडमिन",
    voiceTierViewer: "व्यूअर",
    voiceMinutesUsed: "इस चक्र में {limit} में से {used} उपयोग किया गया",
    voiceMinutesPurchasedExtra: "साथ ही {extra} खरीदे गए — मासिक मिनट खत्म होने के बाद उपयोग होते हैं और कभी समाप्त नहीं होते",
    yourDataSection: "आपका डेटा",
    marketingLabel: "मार्केटिंग संचार सहमति",
    marketingSub: "अपडेट, सूचनाएँ और विशेष ऑफ़र",
    voiceConsentLabel: "Babi के साथ वॉइस चैट",
    voiceConsentSub: "Babi को आपकी बात सुनने और ज़ोर से जवाब देने की अनुमति दें",
    privacyLegalSection: "गोपनीयता, शर्तें और कानूनी जानकारी",
    privacyPolicyLabel: "गोपनीयता नीति",
    privacyPolicySub: "हम आपका डेटा कैसे एकत्र, उपयोग और सुरक्षित करते हैं",
    viewLink: "देखें",
    termsLabel: "सेवा की शर्तें",
    termsSub: "आपके उपयोग को नियंत्रित करने वाले नियम और शर्तें",
    refundLabel: "धनवापसी नीति",
    refundSub: "पात्रता और धनवापसी का अनुरोध कैसे करें",
    cookieSettingsLabel: "कुकी सेटिंग्स",
    cookieSettingsSub: "विश्लेषणात्मक और कार्यात्मक कुकीज़ प्रबंधित करें",
    manageLink: "प्रबंधित करें",
    privacySection: "गोपनीयता और डेटा",
    exportLabel: "मेरा डेटा निर्यात करें",
    exportSub: "अपने प्रोफ़ाइल, प्रगति और फ्लैशकार्ड की JSON फ़ाइल डाउनलोड करें",
    exportBtn: "निर्यात",
    exportDone: "✓ डाउनलोड हो गया",
    cacheLabel: "स्थानीय कैश",
    cacheSub: "सीखने की प्रगति और उदाहरण वाक्य गति के लिए आपके ब्राउज़र में कैश किए जाते हैं।",
    cookieLabel: "कुकी और गोपनीयता सेटिंग्स",
    cookieSub: "विश्लेषण और कुकी प्राथमिकताएं Speafy वेबसाइट पर प्रबंधित की जाती हैं",
    privacyLink: "गोपनीयता नीति ↗",
    aboutSection: "के बारे में",
    aiTutorLabel: "AI ट्यूटर",
    aiTutorSub: "Claude Sonnet — Anthropic द्वारा संचालित",
    algoLabel: "स्मृति एल्गोरिदम",
    algoSub: "FSRS v4.5 — निःशुल्क स्पेस्ड रिपीटिशन शेड्यूलर",
    learningSection: "सीखना",
    placementTestLabel: "प्लेसमेंट टेस्ट",
    placementTestSubNew: "एक छोटे टेस्ट से अपना शुरुआती स्तर पता करें",
    placementTestSubRetake: "पिछला स्तर: {level} · कभी भी दोबारा दे सकते हैं",
    placementTestBtnNew: "टेस्ट दें",
    placementTestBtnRetake: "फिर से टेस्ट दें",
    versionLabel: "संस्करण",
    appearanceSection: "दिखावट",
    darkModeLabel: "डार्क मोड",
    darkModeSub: "डार्क रंग योजना पर स्विच करें",
    largeTextLabel: "बड़ा टेक्स्ट",
    largeTextSub: "आसान पढ़ने के लिए टेक्स्ट का आकार बढ़ाएं",
    babiCheckinsSection: "बाबी चेक-इन",
    babiDailyNudgeLabel: "बाबी का दैनिक प्रोत्साहन",
    babiDailyNudgeSub: "बाबी पूछती है कि आपके पास कितना समय है और हर दिन एक अध्ययन योजना सुझाती है",
    babiWeeklyReportLabel: "बाबी की साप्ताहिक रिपोर्ट",
    babiWeeklyReportSub: "आपकी प्रगति का साप्ताहिक सारांश, सप्ताह में एक बार",
    dangerSection: "खतरा क्षेत्र",
    resetLabel: "सभी प्रगति रीसेट करें",
    resetSub: "आपकी स्ट्रीक, फ्लैशकार्ड और पाठ इतिहास मिटाता है। पूर्ववत नहीं हो सकता।",
    resetBtn: "रीसेट",
    resetConfirmP1: "सभी प्रगति रीसेट करें? यह स्थायी रूप से हटा देगा:",
    resetConfirmC1: "सभी {n} फ्लैशकार्ड और उनका स्मृति डेटा",
    resetConfirmC2: "आपकी स्ट्रीक ({n} दिन) और अध्ययन इतिहास",
    resetConfirmC3: "आप जिस भी भाषा में सीख रहे हैं, उसके सभी पाठ पूर्णता रिकॉर्ड",
    resetConfirmC4: "व्याकरण प्रयोगशाला में आपकी समीक्षा प्रगति",
    resetConfirmP2: "आपका खाता, नाम और भाषा सेटिंग्स सुरक्षित रहेंगी।",
    resetConfirmBtn: "हाँ, सब कुछ रीसेट करें",
    resetting: "रीसेट हो रहा है…",
    resetDone: "✅ प्रगति रीसेट हो गई! आप नए सिरे से शुरू कर रहे हैं।",
    deleteLabel: "खाता हटाएं",
    deleteSub: "आपके खाते और सभी डेटा को स्थायी रूप से हटाता है। पूर्ववत नहीं हो सकता।",
    deleteBtn: "खाता हटाएं",
    deleteConfirmP1: "अपना Speafy खाता स्थायी रूप से हटाएं? यह तुरंत और अपरिवर्तनीय रूप से हटा देगा:",
    deleteConfirmC1: "आपका प्रोफ़ाइल (नाम, भाषा, लक्ष्य)",
    deleteConfirmC2: "सभी {n} फ्लैशकार्ड और स्मृति डेटा",
    deleteConfirmC3: "आपका पूर्ण सीखने का इतिहास और स्ट्रीक",
    deleteConfirmC4: "आपका Firebase प्रमाणीकरण खाता",
    deleteConfirmPrompt: "पुष्टि करने के लिए DELETE (बड़े अक्षरों में) टाइप करें:",
    deleteConfirmBtn: "मेरा खाता स्थायी रूप से हटाएं",
    deleting: "हटाया जा रहा है…",
    cancelBtn: "रद्द करें",
  },
  trial: {
    daysLeftBadge: "⏱ {n} दिन शेष",
    expiredBadge: "ट्रायल समाप्त · अपग्रेड ↑",
    pausedBadge: "⏸ रुकी हुई",
    proBadge: "✦ प्रो प्लान",
    eliteBadge: "✦ Elite प्लान",
  },
  paywall: {
    back: "← वापस",
    title: "Speafy Pro में अपग्रेड करें",
    subTrialExpired: "आपका फ्री ट्रायल समाप्त हो गया। सीखना जारी रखने के लिए अपग्रेड करें।",
    subDefault: "सभी पाठ और फ्लैशकार्ड समीक्षा अनलॉक करें।",
    features: [
      "सभी {count} पाठ पूरी तरह अनलॉक",
      "बाबी, आपके AI शिक्षक के साथ असीमित चैट",
      "स्मार्ट FSRS फ्लैशकार्ड समीक्षा",
      "प्रगति ट्रैकिंग और मेमोरी विश्लेषण",
      "प्रत्येक शब्द पर नेटिव ऑडियो",
      "अभ्यास संवाद",
      "बहुभाषी ऐप इंटरफ़ेस",
    ],
    tierPro: "Pro",
    tierElite: "Elite",
    eliteFeatures: [
      "Speafy Pro में मौजूद सब कुछ",
      "सुनें और बोलें प्रयोगशाला — Babi के साथ मार्गदर्शित बातचीत अभ्यास",
      "हर महीने Babi के साथ 3 घंटे की वॉइस बातचीत",
      "कभी भी अतिरिक्त वॉइस मिनट खरीदें — $3/घंटा",
    ],
    billingMonthly: "मासिक",
    billingYearly: "वार्षिक",
    saveBadge: "25% बचाएं",
    pricePerMonth: "/माह",
    priceBilledYearly: "वार्षिक बिल",
    cta: "Speafy Pro शुरू करें →",
    ctaElite: "Speafy Elite शुरू करें →",
    fine: "कभी भी रद्द करें · Paddle के माध्यम से सुरक्षित भुगतान",
    bannerExpired: "आपका फ्री ट्रायल समाप्त हो गया।",
    bannerActive: "फ्री ट्रायल — {n} दिन शेष।",
    bannerBtn: "अपग्रेड ↑",
    settingsFreePlan: "फ्री प्लान",
    pausedTitle: "आपकी सदस्यता रोकी गई है",
    pausedSub: "नए पाठ फिर से अनलॉक करने के लिए सेटिंग्स में अपनी सदस्यता फिर से शुरू करें।",
    pausedGoToSettingsBtn: "सेटिंग्स पर जाएं",
    alreadyProTitle: "आप पहले से ही Pro हैं!",
    alreadyProSub: "आपकी सदस्यता सक्रिय है — दोबारा खरीदने की ज़रूरत नहीं है।",
    alreadyProGoHomeBtn: "होम पर जाएं",
    settingsTrialRemaining: "ट्रायल — {n} दिन शेष",
    settingsTrialEnded: "ट्रायल समाप्त — सभी पाठ अनलॉक करने के लिए अपग्रेड करें",
    settingsFreeForever: "जहाँ छोड़ा था वहीं से जारी रखें — सभी पाठ अनलॉक करने के लिए अपग्रेड करें",
    settingsUpgradeBtn: "अपग्रेड",
  },
  authAction: {
    verifyingTitle: "आपके ईमेल की पुष्टि की जा रही है…",
    verifiedTitle: "आपका ईमेल सत्यापित हो गया है!",
    verifiedBody: "सब कुछ तैयार है। सीखना जारी रखने के लिए Speafy पर लौटें।",
    continueBtn: "Speafy पर जारी रखें →",
    verifyErrorTitle: "यह लिंक समाप्त हो चुका है",
    verifyErrorBody: "यह सत्यापन लिंक अब मान्य नहीं है। साइन इन करें और हम आपको एक नया लिंक भेजेंगे।",
    resendBtn: "सत्यापन ईमेल फिर से भेजें",
    resendSent: "भेज दिया गया ✓",
    resendError: "फिर से भेजा नहीं जा सका। कृपया थोड़ी देर बाद पुनः प्रयास करें।",
    signInBtn: "साइन इन करें",
    verifyingReset: "आपका लिंक जांचा जा रहा है…",
    resetTitle: "अपना पासवर्ड रीसेट करें",
    resetBodyFor: "{email} के लिए एक नया पासवर्ड चुनें",
    newPasswordPh: "नया पासवर्ड",
    confirmPasswordPh: "नए पासवर्ड की पुष्टि करें",
    resetSubmitBtn: "पासवर्ड रीसेट करें",
    resettingBtn: "रीसेट किया जा रहा है…",
    resetSuccessTitle: "पासवर्ड अपडेट हो गया!",
    resetSuccessBody: "आपका पासवर्ड बदल दिया गया है। अपने नए पासवर्ड से साइन इन करें।",
    resetErrorTitle: "यह लिंक समाप्त हो चुका है",
    resetErrorBody: "यह पासवर्ड रीसेट लिंक अब मान्य नहीं है। साइन-इन स्क्रीन से एक नया लिंक मांगें।",
    passwordMismatch: "पासवर्ड मेल नहीं खाते।",
    passwordTooShort: "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए।",
    genericError: "कुछ गड़बड़ हो गई। कृपया पुनः प्रयास करें।",
    invalidTitle: "यह लिंक अमान्य है या समाप्त हो चुका है",
    invalidBody: "जिस लिंक का आपने अनुसरण किया वह अब मान्य नहीं है। कृपया Speafy पर लौटें और पुनः प्रयास करें।",
    backToSignIn: "साइन इन पर वापस जाएं",
  },

  teacherDash: {
    link: "शिक्षक डैशबोर्ड",
    title: "शिक्षक डैशबोर्ड",
    backHome: "होम पर वापस जाएं",
    studentBadge: "आपके शिक्षक: {name}",
    intro: "अपने छात्रों को Speafy पर लाने और उनकी प्रगति देखने के लिए जो कुछ भी चाहिए, सब यहाँ है।",
    referralTitle: "आपका रेफ़रल लिंक",
    referralBody: "यह लिंक अपने छात्रों के साथ साझा करें। जो भी इसके ज़रिए साइन अप करता है, वह आपके शिक्षक के रूप में आपसे जुड़ जाता है।",
    copy: "लिंक कॉपी करें",
    copied: "कॉपी हो गया",
    studentsTitle: "आपके छात्र",
    studentsLoading: "आपके छात्र लोड हो रहे हैं…",
    studentsError: "अभी आपके छात्रों को लोड नहीं किया जा सका।",
    retry: "फिर कोशिश करें",
    studentsEmpty: "अभी कोई छात्र नहीं है। अपना रेफ़रल लिंक साझा करें — इसके ज़रिए जुड़ने वाले छात्र यहाँ दिखेंगे।",
    colName: "छात्र",
    colJoined: "शामिल हुए",
    colStatus: "सदस्यता",
    colCommission: "अर्जित कमीशन",
    colGrammar: "व्याकरण फोकस",
    statusActive: "सक्रिय",
    statusTrial: "ट्रायल",
    statusNone: "कोई सदस्यता नहीं",
    commissionNote: "यह वह राशि है जो आपने प्रत्येक छात्र से कुल मिलाकर अर्जित की है। भुगतान के लिए उपलब्ध आपका बैलेंस नीचे दिखाया गया है।",
    commissionCapReached: "12 महीने की अवधि समाप्त",
    grammarNote: "व्याकरण की गलतियों का डेटा केवल सक्रिय सदस्यता वाले छात्रों के लिए दिखाया जाता है।",
    studentUnnamed: "छात्र",
    curriculumTitle: "पाठ्यक्रम संदर्भ",
    curriculumBody: "अपने छात्रों द्वारा सीखे जाने वाले हर विषय और शब्द को क्रम से देखें।",
    curriculumLink: "पाठ्यक्रम संदर्भ खोलें",
    profileTitle: "आपकी शिक्षक प्रोफ़ाइल",
    profileBody: "Speafy शिक्षक निर्देशिका शुरू होने पर आप उसमें इस तरह दिखेंगे।",
    profileBio: "संक्षिप्त परिचय",
    profileBioPh: "अपने बारे में और आप कैसे पढ़ाते हैं, इस पर एक-दो वाक्य।",
    profilePhoto: "फ़ोटो",
    photoChoose: "फ़ोटो चुनें",
    photoUploading: "अपलोड हो रहा है…",
    photoRemove: "हटाएं",
    photoHint: "PNG या JPG, अधिकतम 200 KB.",
    photoTypeErr: "कृपया PNG या JPG इमेज चुनें।",
    photoSizeErr: "यह इमेज 200 KB से बड़ी है — कृपया छोटी इमेज चुनें।",
    photoUploadErr: "अपलोड विफल रहा। कृपया फिर से कोशिश करें।",
    profileLink: "निजी वेबसाइट या सोशल मीडिया लिंक",
    profileLinkPh: "www.example.com",
    profileLanguages: "मैं जो भाषाएँ पढ़ाता/पढ़ाती हूँ",
    profileLanguagesHint: "उन भाषाओं को चुनें जो आप पढ़ाते हैं। जैसे-जैसे Speafy उन्हें कोर्स भाषाओं के रूप में जोड़ेगा, और विकल्प खुलते जाएंगे।",
    profileLanguagesSoon: "जल्द आ रहा है",
    save: "सहेजें",
    saving: "सहेजा जा रहा है…",
    saved: "सहेजा गया",
    urlError: "यह एक वेब पते जैसा नहीं लगता। इसे जांचें, या फ़ील्ड को खाली छोड़ दें।",
    termsStatusAccepted: "शिक्षक पार्टनर शर्तें — {date} को स्वीकृत",
    termsStatusPending: "शिक्षक पार्टनर शर्तें — अभी तक स्वीकार नहीं की गईं",
    termsVersionLabel: "संस्करण {version}",
    termsView: "स्वीकृत शर्तें देखें",
    payoutTitle: "भुगतान",
    payoutLoading: "आपकी भुगतान स्थिति लोड हो रही है…",
    payoutError: "हम अभी आपकी भुगतान स्थिति लोड नहीं कर सके।",
    payoutBalance: "आपका मौजूदा बैलेंस: {balance}",
    payoutNotEligible: "आपका बैलेंस {threshold} तक पहुंचने पर आप भुगतान का अनुरोध कर सकेंगे।",
    payoutAlreadyRequested: "भुगतान का अनुरोध किया गया — हम आपसे संपर्क करेंगे।",
    requestPayoutBtn: "भुगतान का अनुरोध करें",
    payoutRequestFailed: "आपका अनुरोध भेजने में कुछ गड़बड़ी हुई। कृपया फिर से प्रयास करें।",
    payoutConfirmTitle: "भुगतान का अनुरोध करें?",
    payoutConfirmBody: "आपके पास अभी अनुरोध के लिए {balance} उपलब्ध है।\n\nइससे एक मैन्युअल भुगतान प्रक्रिया शुरू होती है — कोई भी पैसा अपने आप ट्रांसफर नहीं होता। हम आपके अनुरोध की समीक्षा करेंगे और ईमेल के ज़रिए आपसे संपर्क करेंगे।",
    payoutConfirmBtn: "भुगतान का अनुरोध करें",
    payoutConfirmCancel: "रद्द करें",
  },

  teacherTerms: {
    screenTitle: "शिक्षक पार्टनर शर्तें",
    contents: "विषय-सूची",
    lastUpdatedLabel: "अंतिम अद्यतन",
    effectiveLabel: "प्रभावी तिथि",
    bannerTitle: "कार्रवाई आवश्यक",
    bannerBody: "पार्टनर बने रहने के लिए कृपया शिक्षक पार्टनर शर्तें पढ़ें और स्वीकार करें।",
    bannerCta: "पढ़ें और स्वीकार करें",
    acceptedOn: "आपने ये शर्तें {date} को स्वीकार कीं।",
    acceptedVersion: "स्वीकृत संस्करण: {version}",
    accepting: "आपकी स्वीकृति दर्ज की जा रही है…",
    acceptError: "अभी हम आपकी स्वीकृति दर्ज नहीं कर सके। कृपया फिर से प्रयास करें।",
    draftNotice: "ये शर्तें अभी अंतिम नहीं हैं। प्रभावी तिथि तय होने पर आप इन्हें स्वीकार कर सकेंगे।",
  },
};

export default hi;
